import { commonActions } from '../../../../global-store/subjects/common';
import { isSetOnLocalStorage, WPN_STATUS, WPN_DAILY_SESSION } from '../../../../utils/local-storage';
import { setOptionsFromSdk } from '../../../../utils/push-notifications-utils';
import { unHideElement } from '../../../../utils/dom-utils';
import {
  getSiteName,
  isArticlePage,
  isHomePage,
  isNewsYouCanUsePage,
  isPremiumPage,
} from '../../../../utils/aem-utils';
import { retry } from '../../../../utils/retry';
import { SITE_NAMES } from '../../../../utils/constants';

const WPN_EDIT_LABEL = '#WPNEditLabel';
const ARTICLE_SECTIONS_SELECTOR = '.c-article-section';
const PARAGRAPHS_SELECTOR = 'p';
const $slimBannerBottomWPN = document.querySelector('#slimBannerBottomWPN');
const isSlimBannerBottomWPNOnPage = Boolean($slimBannerBottomWPN);

export const initInDialog = async ({ actions, htmlProps, selectBoxes, sdk, handlers, onShowConfirmModal }) => {
  const isEnabled = {
    common() {
      return (
        !isSlimBannerBottomWPNOnPage &&
        !(Notification.permission === 'denied') &&
        sdk?.canRegister &&
        !sdk?.channel?.optedIn &&
        !isSetOnLocalStorage(WPN_STATUS.OBJECT_KEY) &&
        !isSetOnLocalStorage(WPN_DAILY_SESSION.OBJECT_KEY) &&
        !isPremiumPage()
      );
    },
    [SITE_NAMES.NEWS]() {
      return this.common() && (isHomePage() || isNewsYouCanUsePage());
    },
    [SITE_NAMES.ENTERTAINMENT]() {
      return this.common() && (isHomePage() || isNewsYouCanUsePage());
    },
    [SITE_NAMES.SPORT]() {
      return this.common();
    },
  };

  if (isEnabled[getSiteName()]() && isArticlePage()) {
    const $articleSections = document.querySelectorAll(ARTICLE_SECTIONS_SELECTOR);
    const $lastArticleSection = $articleSections[$articleSections.length - 1];
    const $paragraphs = $lastArticleSection?.querySelectorAll(PARAGRAPHS_SELECTOR);
    const $lastParagraph = $paragraphs?.[$paragraphs.length - 1];
    if ($lastParagraph) {
      const observerCallback = (entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
            // Only when hits the top of the viewport
            onShowConfirmModal();
            observer.unobserve($lastParagraph);
          }
        });
      };
      const observer = new IntersectionObserver(observerCallback);
      observer.observe($lastParagraph);
    } else {
      onShowConfirmModal();
    }
  }
  if (isEnabled[getSiteName()]() && !isArticlePage()) {
    onShowConfirmModal();
  }
  if (!isEnabled[getSiteName()]()) {
    setOptionsFromSdk({ sdk, selectBoxes: htmlProps.selectBoxes, actions });
    commonActions.setPushNotificationInDialogShow(false);
  }

  retry({
    maxAttempts: 3,
    checkEvery: 5000,
    checkFunction: () => document.querySelector(WPN_EDIT_LABEL),
  })
    .then(() => {
      const $WPNEdit = document.querySelector(WPN_EDIT_LABEL);
      unHideElement($WPNEdit?.parentNode);
      $WPNEdit?.addEventListener('click', () => {
        handlers.handleWPNEditClick(selectBoxes);
      });
    })
    .catch((e) => console.error('[WPN] Edit label wont be shown', e));
};
